import { baseUrl, httpClient } from 'src/pages/admin/providers/AppDataProvider';

import type { ApiResponse, EmergencyFusePayload } from './types';
import { normalizeFuseState } from './utils';

const resourceBase = 'world-cup/emergency-fuse';

function unwrap<T>(json: ApiResponse<T> | T): T {
  if (json && typeof json === 'object' && 'data' in json) {
    return (json as ApiResponse<T>).data;
  }

  return json as T;
}

async function request<T>(options: RequestInit = {}): Promise<T> {
  const { json } = await httpClient(`${baseUrl}/${resourceBase}`, options as any);

  return unwrap<T>(json);
}

export const emergencyFuseApi = {
  async getState(signal?: AbortSignal) {
    const data = await request<unknown>({
      method: 'GET',
      signal,
    } as any);

    return normalizeFuseState(data);
  },

  async updateState(payload: EmergencyFusePayload) {
    const data = await request<unknown>({
      method: 'PUT',
      body: JSON.stringify(payload),
    });

    return normalizeFuseState(data);
  },
};
